import {
  FetchSettingsRequest,
  FetchSettingsSuccess,
  FetchSettingsFailure,
  UpdateSettingsSuccess,
  UpdateSettingsFailure,
  UpdateSettingsRequest,
} from './settings.actions'
import { SettingsService } from './settings.service'
import { ShowSnackbar } from './../../shared/shared.actions'
import { Injectable } from '@angular/core'
import { Observable, of } from 'rxjs'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import * as SettingsTypes from './settings.types'
import { map, switchMap, tap, catchError } from 'rxjs/operators'
import { Router } from '@angular/router'

@Injectable()
export class SettingsEffects {
  constructor(
    private actions: Actions,
    private settingsService: SettingsService,
    private router: Router,
  ) {}

  FetchSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(SettingsTypes.FETCH_SETTINGS_REQUEST),
      switchMap((action: FetchSettingsRequest) => {
        return this.settingsService.fetchSettings().pipe(
          switchMap((result) => {
            return [
              new FetchSettingsSuccess(result.data),
              new FetchSettingsSuccess(result.data),
            ]
          }),
          catchError((err, caught) => {
            return of(new FetchSettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(SettingsTypes.UPDATE_SETTINGS_REQUEST),
      switchMap((action: UpdateSettingsRequest) => {
        return this.settingsService.updateSettings(action.payload).pipe(
          switchMap((result) => {
            return [new UpdateSettingsSuccess(), new FetchSettingsRequest()]
          }),
          catchError((err, caught) => {
            return of(new UpdateSettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )
}
